import { useEffect, useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { transactionsService } from '../services/transactionService'
import { useToast } from '@/view/components/ui/use-toast'
import { getAvailableCreditParams } from '../services/transactionService/getAvailableCredit'

export const useGetAvailableCredit = (cpf: number) => {
  const [params, setParams] = useState<getAvailableCreditParams | undefined>({})
  const { isError, isFetching, data, isLoading } = useQuery({
    queryKey: ['getAvailableCredit', cpf, params],
    queryFn: () => transactionsService.getAvailableCredit(Number(cpf), params),
  })

  const { toast } = useToast()

  useEffect(() => {
    if (isError) {
      toast({
        variant: 'destructive',
        title: 'Erro ao carregador os dados, tente novamente mais tarde!',
      })
    }
  }, [isError, toast])

  return {
    isLoading,
    isFetching,
    data,
    setParams,
    params,
  }
}
